import { render, staticRenderFns } from "./ChatInputBox.vue?vue&type=template&id=124f7aa4&scoped=true"
import script from "./ChatInputBox.vue?vue&type=script&lang=js"
export * from "./ChatInputBox.vue?vue&type=script&lang=js"
import style0 from "./ChatInputBox.vue?vue&type=style&index=0&id=124f7aa4&prod&scoped=true&lang=css"
import style1 from "./ChatInputBox.vue?vue&type=style&index=1&id=124f7aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f7aa4",
  null
  
)

export default component.exports